<template>
  <div class="modal config">
    <div class="empty" @click="emits('close')"></div>
    <div class="box">
      <div class="top">
        <div class="title">Configurações</div>
        <div class="close" @click="emits('close')"><i class="fa-solid fa-xmark"></i></div>
      </div>
      <div class="content">
        <div class="left">
          <ul>
            <li :class="{active: activeComponent === 'AltAvatar'}" @click="activeComponent = 'AltAvatar'"><p>Alterar
              avatar</p></li>
            <li :class="{active: activeComponent === 'AltBackg'}" @click="activeComponent = 'AltBackg'"><p>Alterar
              background</p></li>
            <li :class="{active: activeComponent === 'AltPass'}" @click="activeComponent = 'AltPass'"><p>Alterar
              senha</p></li>
            <li :class="{active: activeComponent === 'OpenTic'}" @click="activeComponent = 'OpenTic'"><p>Abrir
              ticket</p></li>
            <li :class="{active: activeComponent === 'MineTic'}" @click="activeComponent = 'MineTic'"><p>Meus
              tickets</p></li>
            <li :class="{active: activeComponent === 'MyArt'}" @click="activeComponent = 'MyArt'"><p>Minhas artes</p>
            </li>
            <li :class="{active: activeComponent === 'MyBadges'}" @click="activeComponent = 'MyBadges'"><p>Alterar
              emblemas</p></li>
          </ul>
        </div>
        <div class="subcontent">
            <Transition name="custom-classes" enter-active-class="animate__animated animate__faster animate__flipInX">
              <component :is="components[activeComponent]" :key="activeComponent" @textAlerta="setAlert($event)"
                         @TickChat="ticketId" :ticketid="tickId"
              ></component>
            </Transition>
        </div>
      </div>
    </div>
    <Transition name="slide-fade">
      <Alerta v-if="textA !== ''" :text="textA" />
    </Transition>
  </div>
</template>

<script setup>
import Alerta from '@/components/usefulness/alert.vue'

import AltAvatar from '@/components/configs/avatar.vue'
import AltPass from '@/components/configs/pass.vue'
import OpenTic from '@/components/configs/open-ticket.vue'
import MineTic from '@/components/configs/mine-tickets.vue'
import MyArt from '@/components/configs/mine-arts.vue'
import ChatTicketItem from '@/components/configs/chatTicket.vue'
import AltBackg from '@/components/configs/capa-perfil.vue'
import MyBadges from '@/components/configs/my-badges.vue'
import { ref } from 'vue'

const emits = defineEmits(['textAlerta', 'close'])
const components = {
  AltAvatar,
  AltPass,
  OpenTic,
  MineTic,
  MyArt,
  ChatTicketItem,
  AltBackg,
  MyBadges
}

const activeComponent = ref('AltAvatar')
const textA = ref('')
const tickId = ref(0)

function setAlert(t) {
  textA.value = t
  setTimeout(() => {
    textA.value = ''
  }, 3000)
}

function ticketId(i) {
  tickId.value = i
  activeComponent.value = 'ChatTicketItem'
}


setTimeout(() => {
  textA.value = ''
}, 3000)

</script>

<style scoped>
.config .box {
  position: relative;
  width: 540px;
  max-width: calc(100vw - 24px);
  height: 340px;
  max-height: calc(100vh - 24px);
}

.config .box .top {
  height: 50px;
}

.config .box .content {
  float: left;
  width: 100%;
  height: calc(100% - 50px);
  padding: 0;
  display: flex;
  justify-content: space-between;
  z-index: 0;
}

.config .box .content .left {
  position: relative;
  top: 0;
  left: 0;
  width: 38%;
  height: auto;
  background-color: #EFF2F5;
  border-bottom-left-radius: 12px;
}

/* .config .box .content .left::before {
	content: '';
	width: 100%;
	height: 100%;
	position: relative;
	top: 0;
	left: 0;
	background-color: #EFF2F5;
} */

.config .box .content .left ul {
  float: left;
  margin-top: 10px;
}

.config .box .content .left li {
  float: left;
  width: 100%;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  font-weight: 300;
  padding: 0 10px;
  cursor: pointer;
  margin-top: 2px;
}

.config .box .content .left li.active p {
  font-weight: 600;
  transition: all .2s ease;
}

.config .box .content .left li:nth-child(2n) {
  background-color: #E4E9EE;
}

.config .box .content .subcontent {
  position: relative;
  top: 0;
  right: 0;
  width: 62%;
  height: auto;
  padding-bottom: 10px;
  z-index: 1;
  overflow: auto;
}

.subModal {
  position: relative;
  width: 100%;
  height: auto;
  padding: 8px;
}

:deep(.subModal form) {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

:deep(.subModal input),
:deep(.subModal textarea) {
  width: 100%;
}
</style>
